import { render, staticRenderFns } from "./distributionDialog.vue?vue&type=template&id=21d9252a&scoped=true&"
import script from "./distributionDialog.vue?vue&type=script&lang=js&"
export * from "./distributionDialog.vue?vue&type=script&lang=js&"
import style0 from "./distributionDialog.vue?vue&type=style&index=0&id=21d9252a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d9252a",
  null
  
)

export default component.exports